<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import type { BookAndArticle } from '~/utils/solr/literature'

const { book } = defineProps<{
  book: BookAndArticle
}>()

const bookEditions = useFetchBookEditions(book.id)

const hasLicense = useHasContentLicense()

function getEditionLink(edition: BookAndArticle) {
  if (hasLicense.value) {
    return { name: 'book-by-id', params: { bokId: [edition.id] } } satisfies RouteLocationRaw
  }
  return { name: 'book-about-by-id', params: { bokId: edition.id } } satisfies RouteLocationRaw
}

const relatedEditions = computed(() => {
  return bookEditions.data.value?.editions.filter(
    edition => edition.id !== book?.id,
  ) ?? []
})
</script>

<template>
  <LiteratureRelationListSkeleton v-if="bookEditions.isLoading.value" />
  <div v-else-if="relatedEditions.length > 0" class="flex flex-col gap-m items-center min-[865px]:items-start">
    <h4 class="text-center min-[865px]:text-left">
      Andre utgaver av denne boken
    </h4>
    <div class="flex flex-col xl:flex-row gap-m justify-start flex-wrap">
      <LiteratureCard
        v-for="relatedBook in relatedEditions"
        :key="relatedBook.id"
        :to="getEditionLink(relatedBook)"
        :title="relatedBook.title ?? ''"
        :image="relatedBook.coverImage ?? ''"
        :edition-number="relatedBook.editionNumber ?? '' "
        :release-year="relatedBook.year"
        size="small"
      />
    </div>
  </div>
</template>
